<template>
  <div class="sdf-pagination">
    <p class="section-title">表示数</p>
    <vs-dropdown vs-trigger-click class="dropdown" :color="sdfColor.Blue">
      <a class="a-icon" href="#">
        {{displayFrom}}-{{displayTo}}/{{totalItems}}
        <span class="arrow"></span>
      </a>

      <vs-dropdown-menu class="sdf-pagination-dropdown-menu">
        <vs-dropdown-item
          v-for="(option, index) in itemsPerPageOptions"
          :key="index"
          @click="setItemsPerPage(option)">
          {{option}}
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
    <p class="section-title">ページ</p>
    <div>
      <vs-pagination
        :color="sdfColor.Blue"
        :total="totalPages"
        v-model="currentPagePagination"
        class="pagination-section"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>

import SecureDataflowMixin from "@/mixins/SecureDataflowMixin";
export default {
  name: "sdfPagination",
  props: ["currentPage", "totalItems"], // syncで受ける
  mixins: [SecureDataflowMixin],
  data() {
    return {
      currentPagePagination: this.currentPage,
      itemsPerPage: 10,
      itemsPerPageOptions: [
        10, 20, 30
      ],
    }
  },
  watch: {
    currentPagePagination(value) {
      this.$emit("update:currentPage", value);
    }
  },
  computed: {
    totalPages() {
      return Math.floor(this.totalItems / this.itemsPerPage + 1);
    },
    displayFrom() {
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },
    displayTo() {
      let to = (this.currentPage - 1) * this.itemsPerPage + this.itemsPerPage;
      return to > this.totalItems ? this.totalItems : to;
    }
  },
  methods: {
    setItemsPerPage(option) {
      this.itemsPerPage = option;
      this.currentPagePagination = 1;
      this.$emit("update:currentPage", 1);
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/_variables.scss";
.sdf-pagination-dropdown-menu {
  .vs-dropdown--menu {
    border: 2px solid #346C88;
  color: $white;
  background: #143243;
  }
  .vs-dropdown--menu--after {
    border-top: 2px solid #346C88;
    border-left: 2px solid #346C88;
    background: #143243;
    z-index: 300;
  }
}

.sdf-pagination {
  display: flex;
  align-items: center;
  .section-title {
    margin-right: 13px;
    margin-left: 18px;
  }
  .pagination-section {
    margin-top: 5px;
  }
  .dropdown {
    height: 36px;
    border: 2px solid #346C88;
    border-radius: 3px;
    padding: 1px 55px 1px 10px;
  }
  p {
    color: #779EB8;
  }
  a {
    color: $white !important;
  }
  .arrow{
    z-index: 2;
    border-color: $navy;
    border-style: solid;
    border-width: 10px;
    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
    margin-left: 27px;
    margin-bottom: 10px;
    position: absolute;
    margin-top: 4px;
    pointer-events: none;
  }
}
</style>
